import React, { useContext, useEffect, useState } from 'react';
import Frame from '../../b2b-common/Frame';
import LabelTranslated from '../../b2b-languages/components/LabelTranslated';

import './WeigthedValueForm.css';
import B2BButtonGroup from '../../b2b-common/B2BButtonGroup';
import { Add, Cancel, Delete, Edit } from '@mui/icons-material';
import { LoginContext } from '../../../App';
import { TextField } from '@mui/material';

const WeigthedValueForm = ({ weightedValue = null, onUpdate, onDelete, onClose }) => {

    const { loginData } = useContext(LoginContext);

    const emptyWeightedValue = {
        "qualitativeWeightedValueId": 0,
        "qualitativeTypeId": 0,
        "qualitativeWeightedLabel": null,
        "qualitativeWeightedLabel_label": null,
        "qualitativeWeightedDescription": null,
        "qualitativeWeightedDescription_label": null,
        "qualitativeWeightedValue": 0
    }
    const [currentWeightedValue, setCurrentWeightedValue] = useState(emptyWeightedValue);

    useEffect(() => {
        if (weightedValue)
            setCurrentWeightedValue(weightedValue);
    }, [weightedValue]);

    return (
        <Frame title={(!weightedValue) ? "New weighted value" : "Existing weighted value"} className="weighted-form">
            <div className="weighted-form-fields">
                <LabelTranslated
                    field="Label" labelValue={currentWeightedValue.qualitativeWeightedLabel_label}
                    onChange={(e) => setCurrentWeightedValue({ ...currentWeightedValue, qualitativeWeightedLabel_label: e.target.value })}
                    className="weighted-label"
                    locale={`Label [${loginData.locale}]`}
                    translation={currentWeightedValue.qualitativeWeightedLabel} />
                <TextField
                    variant='standard'
                    label="Value"
                    value={currentWeightedValue.qualitativeWeightedValue}
                    onChange={(e) => setCurrentWeightedValue({ ...currentWeightedValue, qualitativeWeightedValue: e.target.value })}
                    className="weighted-value"
                />
                <LabelTranslated
                    field="Description" labelValue={currentWeightedValue.qualitativeWeightedDescription_label}
                    onChange={(e) => setCurrentWeightedValue({ ...currentWeightedValue, qualitativeWeightedDescription_label: e.target.value })}
                    className="weighted-description"
                    locale={`Description [${loginData.locale}]`}
                    translation={currentWeightedValue.qualitativeWeightedDescription} />
            </div>
            {!weightedValue && (
                <B2BButtonGroup className="b2b-weighted-form-buttons-group"
                    buttonConfigs={[
                        {
                            label: 'Add', icon: <Add />, onClick: () => {
                                onUpdate(currentWeightedValue);
                                onClose();
                            }
                        },
                        { label: 'Cancel', icon: <Cancel />, onClick: () => onClose() }
                    ]}
                />
            )}
            {weightedValue && (
                <B2BButtonGroup className="b2b-weighted-form-buttons-group"
                    buttonConfigs={[
                        {
                            label: 'Update', icon: <Edit />, onClick: () => {
                                onUpdate(currentWeightedValue);
                                onClose();
                            }
                        },
                        {
                            label: 'Delete', icon: <Delete />, onClick: () => {
                                onDelete(currentWeightedValue);
                                onClose();
                            }
                        },
                        { label: 'Cancel', icon: <Cancel />, onClick: () => onClose() }
                    ]}
                />
            )}
        </Frame>
    );
};

export default WeigthedValueForm;
